import * as React from 'react';
import styled from '../../../utils/styled';
import {margin} from 'polished';
import {BreadcrumbItemRendererProps} from '../types';

const Root = styled('span')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: theme.fontSize.small,
  lineHeight: 1.5,
  color: '#1B202A'
}));

const Link = styled('a')(({theme}) => ({
  color: '#7E8DA6',
  textDecoration: 'none',
  ':hover': {
    color: theme.color.primary
  }
}));

const Separator = styled('span')({
  color: '#C5CAD4',
  ...margin(0, 8)
});

export default class BreadcrumbItemRenderer extends React.Component<BreadcrumbItemRendererProps, {}> {
  public render() {
    const {children, href, current, separator, ...restProps} = this.props;

    const contents = href && !current ? <Link href={href}>{children}</Link> : children;

    return (
      <Root {...restProps}>
        {contents}
        <Separator>{separator}</Separator>
      </Root>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/private/BreadcrumbItemRenderer.tsx